import React from 'react';
import { useTheme, Menu, Pressable, HStack, Text, Box } from 'native-base';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faListRadio } from '@fortawesome/pro-solid-svg-icons/faListRadio';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faRectangleHistory } from '@fortawesome/pro-solid-svg-icons/faRectangleHistory';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import FRNMenu from '../content/common/reusables/FRNMenu';
const Filter = ({
  selectedFilter,
  setSelectedFilter,
  isFilterOpen,
  setIsFilterOpen
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const options = [{
    name: 'All',
    value: 0,
    icon: faRectangleHistory
  }, {
    name: 'Read',
    value: 1,
    icon: faCheck
  }, {
    name: 'Unread',
    value: 2,
    icon: faTimes
  }];
  return /*#__PURE__*/React.createElement(Box, {
    maxW: "24px",
    maxH: "24px",
    alignSelf: "flex-end",
    right: "1vw",
    bottom: "3vh"
  }, /*#__PURE__*/React.createElement(FRNMenu, {
    trigger: triggerProps => /*#__PURE__*/React.createElement(Pressable, triggerProps, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faListRadio,
      color: colors.activity.text,
      size: 24
    })),
    isOpen: isFilterOpen,
    onOpen: () => setIsFilterOpen(true),
    onClose: () => setIsFilterOpen(false)
  }, /*#__PURE__*/React.createElement(Menu.Item, {
    alignSelf: "flex-end",
    p: "0",
    onPress: () => setIsFilterOpen(false),
    maxW: "24px",
    maxH: "24px",
    right: "4"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCircleXmark,
    color: colors.activity.text,
    size: 24
  })), options.map(option => {
    const isSelected = selectedFilter === option.name;
    return /*#__PURE__*/React.createElement(Menu.Item, {
      onPress: () => setSelectedFilter(option.name),
      isDisabled: isSelected
    }, /*#__PURE__*/React.createElement(HStack, {
      space: 4,
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: option.icon,
      color: isSelected ? colors.activity.selectedFilter : colors.activity.text,
      size: 16
    }), /*#__PURE__*/React.createElement(Text, {
      color: isSelected ? colors.activity.selectedFilter : '#000'
    }, option.name)));
  })));
};
export default Filter;
//# sourceMappingURL=Filter.js.map